import { IconButton, styled, Link } from '@mui/material'

export const StyledIconButton = styled(IconButton)`
  width: 26px;
  height: 26px;
`

export const StyledLink = styled(Link)`
  text-decoration: none;
  width: 100%;
`
